import ReactDOM from 'react-dom';
// import './assets/styles/sass/index.scss';
import { routing } from './AppRouting';

ReactDOM.render(routing, document.getElementById('root'));
